// extracted by mini-css-extract-plugin
export var component = "layout-module--component--BjJhQ";
export var componentWidthArticleFull = "layout-module--component-width-article-full--TfgJM";
export var componentWidthArticleNarrow = "layout-module--component-width-article-narrow--99Zjo";
export var componentWidthArticleSidebar = "layout-module--component-width-article-sidebar--bf1kG";
export var componentWrapperPadding = "layout-module--component-wrapper-padding--jD+0T";